import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class DismissActivityCommand extends BasicCommand<DismissActivityCommand> {
    get primaryKey(): IPrimaryKey<DismissActivityCommand> {
        return {
            id: this.id
        };
    }
    id: number;
    dismissAllOfType: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DismissActivityCommand";
    constructor(id: number, dismissAllOfType = false) {
        super(DismissActivityCommand.$type, "Activities", CommandType.Replace);
        this.id = id;
        this.dismissAllOfType = dismissAllOfType;
    }
}
